import { ElasticCobaltSortKeyEnumType } from '@mark43/cad-api';
import { createContext, ReactNode, useContext } from 'react';
import {
    ElasticSortKeyOption,
    ElasticSortTypeOption,
    SortContextType,
    useSearchSort,
} from '../search-windows/use-search-sort';

const sortByOptions: ElasticSortKeyOption[] = [
    {
        label: 'Date / Time',
        value: 'UNIT_STATUS_START_DATE_UTC',
    },
    { label: 'Event #', value: 'UNIT_STATUS_AGENCY_EVENT_NUMBER' },
    { label: 'Priority', value: 'UNIT_STATUS_AGENCY_EVENT_GLOBAL_PRIORITY' },
    { label: 'Agency Type', value: 'UNIT_STATUS_AGENCY_TYPE' },
];

const directionOptionsBySortKey: Partial<
    Record<ElasticCobaltSortKeyEnumType, ElasticSortTypeOption[]>
> = {
    UNIT_STATUS_START_DATE_UTC: [
        {
            label: 'Newest First',
            value: 'DATE_MOST_RECENT_TO_LEAST_RECENT',
        },
        {
            label: 'Oldest First',
            value: 'DATE_LEAST_RECENT_TO_MOST_RECENT',
        },
    ],
    UNIT_STATUS_AGENCY_EVENT_NUMBER: [
        { label: '1 - 9', value: 'ALPHABETICAL_A_TO_Z' },
        { label: '9 - 1', value: 'ALPHABETICAL_Z_TO_A' },
    ],
    UNIT_STATUS_AGENCY_EVENT_GLOBAL_PRIORITY: [
        {
            label: 'Highest First',
            value: 'PRIORITY_HIGHEST_TO_LOWEST',
        },
        {
            label: 'Lowest First',
            value: 'PRIORITY_LOWEST_TO_HIGHEST',
        },
    ],
    UNIT_STATUS_AGENCY_TYPE: [
        {
            label: 'Ascending',
            value: 'NUMBER_LOWEST_TO_HIGHEST',
        },
        {
            label: 'Descennding',
            value: 'NUMBER_HIGHEST_TO_LOWEST',
        },
    ],
};

const SortContext = createContext<SortContextType | undefined>(undefined);

export function useUnitStatusSearchSortContext() {
    const context = useContext(SortContext);
    if (context === undefined) {
        throw new Error(
            'useUnitStatusSearchSortContext must be used within a UnitStatusSearchSortProvider'
        );
    }
    return context;
}

export const UnitStatusSearchSortProvider = ({ children }: { children: ReactNode }) => {
    const sort = useSearchSort(sortByOptions, directionOptionsBySortKey);
    return <SortContext.Provider value={sort}>{children}</SortContext.Provider>;
};
